import { Box, ClickAwayListener, Popover } from "@mui/material";
import { Dashboard } from "../../../../../types/files";
import DescriptionContentCard from "../../../../molecules/home-companies/DescriptionContentCard";

const DescriptionModal: React.FC<{
    open: boolean,
    dashboard: Dashboard,
    newDescription?: boolean,
    anchorElement?: HTMLElement|null,
    onClose: () => void,
 }> = ({ open, dashboard, newDescription, anchorElement, onClose }) => {
    return (<>
        <Popover open={open} anchorEl={anchorElement}>
            <ClickAwayListener onClickAway={onClose}>
                <Box width="fit-content" height="fit-content">
                    <DescriptionContentCard
                        newDescription={newDescription}
                        dashboard={dashboard}
                        onClose={onClose} />
                </Box>
            </ClickAwayListener>
        </Popover>
    </>);
}

export default DescriptionModal;